module.exports = "/assets/c75ee0d17b2355efb67fa32ac8ca6582.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FJ.png
// module id = 1371
// module chunks = 0